import type { LivesState } from './LivesState';
import { LIVES_MAX, LIVES_REFILL_DURATION } from './LivesConstants';
import { getMsUntil, MS_IN_MINUTE } from '../../../utils/time-utils';

function getLivesMax(livesState: LivesState): number {
  return livesState.maxLives ?? LIVES_MAX;
}

export function canRefillLife(livesState: LivesState): boolean {
  return Date.now() >= livesState.lastLifeAt + LIVES_REFILL_DURATION && livesState.count < getLivesMax(livesState);
}

export function refillLives(livesState: LivesState): void {
  while (canRefillLife(livesState)) {
    livesState.lastLifeAt += LIVES_REFILL_DURATION;
    livesState.count += 1;
  }
}

export function setMaxLives(livesState: LivesState): void {
  if (livesState.count >= getLivesMax(livesState)) return;
  livesState.lastLifeAt = Date.now();
  livesState.count = getLivesMax(livesState);
}

export function removeLives(livesState: LivesState, lives: number): void {
  if (livesState.count === getLivesMax(livesState)) livesState.lastLifeAt = Date.now();
  livesState.count = Math.max(livesState.count - lives, 0);
}

export function getTimeUntilNextLife(livesState: LivesState): number {
  return getMsUntil((livesState.lastLifeAt ?? 0) + LIVES_REFILL_DURATION);
}

export function setUnlimitedLivesTime(livesState: LivesState, minutes: number): void {
  livesState.unlimitedUntil = Date.now() + minutes * MS_IN_MINUTE;
}

export function getUnlimitedLivesMinutes(livesState: LivesState): number {
  const currentTime = Date.now();
  const { unlimitedUntil = currentTime } = livesState;
  return Math.max(unlimitedUntil - currentTime, 0) / MS_IN_MINUTE;
}
